import { Injectable, OnDestroy } from '@angular/core';
import { ExtendedRender } from '@App/app/entities/processing/render.model';
import { ModelsProcessingHttpService } from '@App/app/pages/processing/services/models-processing-http-service/models-processing-http.service';
import { BehaviorSubject } from 'rxjs';

const NO_LOGS_MESSAGE = 'No logs available';

@Injectable()
export class BuildProcessLogsService implements OnDestroy {
  buildProcessLogs$: BehaviorSubject<string>;
  buildProcessATLogs$ = new BehaviorSubject<string>(NO_LOGS_MESSAGE);
  buildProcessProdLogs$ = new BehaviorSubject<string>(NO_LOGS_MESSAGE);

  constructor(private modelsProcessingService: ModelsProcessingHttpService) {}

  downloadLogs(render: ExtendedRender | null): void {
    if (!render) {
      return;
    }

    this.buildProcessATLogs$.next('Loading AT logs...');
    this.modelsProcessingService
      .getBuildProcessLogs(render.atLog?.downloadURL as string)
      .subscribe({
        next: (logs) => {
          this.buildProcessATLogs$.next(logs);
        },
        error: (error) => {
          const errorMessage = 'Failed to load AT logs';
          this.buildProcessATLogs$.next(errorMessage);
        },
      });

    this.buildProcessProdLogs$.next('Loading Production logs...');
    this.modelsProcessingService
      .getBuildProcessLogs(render.prodLog?.downloadURL as string)
      .subscribe({
        next: (logs) => {
          this.buildProcessProdLogs$.next(logs);
        },
        error: (error) => {
          const errorMessage = 'Failed to load Production logs';
          this.buildProcessProdLogs$.next(errorMessage);
        },
      });
  }

  ngOnDestroy(): void {
    this.buildProcessATLogs$.complete();
    this.buildProcessProdLogs$.complete();
  }
}
